import $ from 'jquery';
import 'tooltipster';

class Tooltip {
  init() {
    this.tooltip = $('.tooltip');
    this.tooltip.tooltipster({
      theme: 'tooltipster-borderless',
    });
  }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/scripts/modules/tooltip.js